
import { mapState } from "vuex";
import { getCategory } from '@/api/product'
import { setSeacher,getSukerList } from '@/api/sucker'

export default {
    data () {
        return {
            //h5
            showBottomPosition: false,
            result: [],
            h5List: [],
            h5One: [],
            h5Two: [],
            h5SearchList: [],
            newH5Data: {},
            H5RadioDefalut: {},
            type: '',
            h5_list: [],
            goto: true,
            value1: '',
            value2: ''
        }
    },
    methods: {
        searchH5 (id,type) {
            console.log('---',id,this.currentId,this.H5RadioDefalut);
            // this.result = []
            // console.log('查看有没有key',Object.keys(this.newH5Data));
            if (id == '184') {
                this.H5RadioDefalut = this.value1
            } else if (id == '189') {
                // this.H5RadioDefalut = this.value2
            }
            if (Object.keys(this.newH5Data).indexOf('184') != -1 && Object.keys(this.newH5Data).indexOf('189') != -1) {
                this.goto = true
                if (id == '184') {
                    
                    Object.keys(this.newH5Data).forEach(ele => {
                        if (ele != '184') {
                            delete this.newH5Data[ele]
                        }
                    })
                    this.h5List[1].title = '移液器最大量程'
                    // console.log('-------------------../.',this.newH5Data);
                }
            } else {
                this.goto = true
                // if (id != this.currentId) {
                //     this.goto = true
                // } else {
                //     this.goto = true
                // }
            }
           
            this.currentId = id
            let keys = Object.keys(this.newH5Data);
            // console.log('----11111',keys);
            if (type != 'blue') { // 限制
                
                if(keys.indexOf('184') == -1 || keys.indexOf('189') == -1) {
                    this.$toast('请先选择蓝色区域的筛选')
                    return
                }
            }
            
            this.type = id
            
            this.showBottomPosition = true
            // this.$refs.checkboxGroup.toggleAll(false);
            let newData = this.h5List.filter(ele => {
                if (ele.id == id) {
                    return ele
                }
            })
            
            this.h5SearchList = newData[0].children
            console.log('===',this.h5SearchList);
            // console.log('---',id,this.currentId);
            if (type == 'blue' && this.goto) {
                if (this.currentId == 184) {
                    this.handleShow(newData[0],'cid_to',this.value2)
                } else {
                    this.handleShow(newData[0],'to_cid',this.value1)
                }
            }
        },
        handleShow (newData,categoryId,newId) {
            
            if (this.H5RadioDefalut) {
                // console.log('一级的',newId)
                let oneid = ''
                for (let key in this.newH5Data) { 
                    if (this.newH5Data[key] == newId) {
                        oneid = key
                    }
                }
                let twoList = this.h5List.filter(ele => {
                    if (ele.id == oneid) {
                        return ele
                    }
                })
                // console.log('一级的列表',twoList)
                if (twoList.length > 0) {
                    let tocid = twoList[0].children.filter(ele => {
                        if (ele.id == newId) {
                            return ele
                        }
                    })
                    let lastCid = ''
                    
                    if (categoryId == 'to_cid') {
                        lastCid = tocid[0].to_cid
                    } else {
                        lastCid = tocid[0].cid_to
                    }
                    // console.log('一级的',lastCid) 
    
                    let vv = newData.children.filter(ele => {
                        let aa = lastCid.filter(val => {
                            if (+ele.id == val) {
                                return ele
                            }
                        })
                        if (aa.length > 0) {
                            return aa
                        }
                    })
                    console.log('一级的最后',vv) 
                    this.h5SearchList = vv
                }
            }
        },
        handleceshi (data1,data2) {
            // console.log('多选框======',data1,data2);
            if (data1 == 184) {
                this.h5List[0].title = data2
            } else if (data1 == 189) {
                this.h5List[1].title = data2
            }
            
        },
        handleH5Se (val) {
            // console.log('多选框22',val);
            if (typeof(val) == 'number') {
                val = [val]
                
            }
            this.newH5Data[this.type] = val
            // console.log('多选框11',this.newH5Data[this.type]);
            
            
            
            for (let key in this.newH5Data) {
                if (this.newH5Data[key].length == 0) {
                    delete this.newH5Data[key]
                }
            }
            // this.H5RadioDefalut[this.currentId] = this.newH5Data[this.type][0]
            if(this.newH5Data[this.type]) {
                if (this.currentId == '184') {
                    this.value1 = this.newH5Data[this.type][0]
                } else if (this.currentId == '189') {
                    if (this.newH5Data[this.type][0]) {
                        this.value2 = this.newH5Data[this.type][0]
                    }
                    
                } else {
                    
                }
            }
            // val.length>this.h5_list.length
            if(val.length>0){
                let para = {
                    type:2, 
                    type_id: val[val.length-1],
                    uid: this.$store.state.user.id || 0,
                    action: 1
                }
                this.setPurFrequency(para)
            }
            this.h5_list=JSON.parse(JSON.stringify(val))
            // console.log('多选框11',this.newH5Data);
            
            if (this.currentId == '173') {
                let bb = this.newpackList.filter(ele => {
                    let aa = val.filter(res => {
                        if (ele.id == res) {
                            return ele
                        }
                    })
                    if (aa.length > 0) {
                        return aa
                    }
                })
                this.packList = bb.length > 0? bb: this.newpackList
                
            }
            // console.log('包装',this.packList);
            
            
        },
        determine (type,data) { // 确定
            let keys = Object.keys(this.newH5Data);
            console.log('==确定11',this.h5List[1].title);
            if(keys.indexOf('184') != -1 && keys.indexOf('189') != -1) {
                // console.log('==确定隐藏',this.currentId);
                this.isShowTwo = true
            } else {
                this.isShowTwo = false
            }

            let bb = Object.values(this.newH5Data)
            var cc = []
            bb.forEach(ele => {
                cc.push(...ele)
            })
            console.log([...new Set(cc)]);
            this.allSearch = [...new Set(cc)]
            this.showBottomPosition = false
            this.page = 1
            
            this.getProList(this.newH5Data)
        },
        toggleAll () {
            // this.$refs.checkboxGroup.toggleAll(false);
            // this.result = []
            this.newH5Data[this.type] = []
            this.value1 = ''
            this.value2 = ''
            this.H5RadioDefalut = ''
        },
        
    }
}